import React from 'react';
import { useTranslation } from 'react-i18next';

import { getMarket } from '../../i18n';
import { Container } from '../../styled-components/components/Container';
import { H1 } from '../../styled-components/components/Heading';
import { RouterLink } from '../../styled-components/components/Link';
import { MaxWidth } from '../../styled-components/components/MaxWidth';
import { Page, PageSection } from '../../styled-components/components/Page';
import { Text } from '../../styled-components/components/Text';
import { VStack } from '../../styled-components/components/VStack';
import { TEXT_CONTENT_MAX_WIDTH } from '../../styled-components/layout/constants';

const resolveCustomerServiceRoute = () => {
  const { marketCode } = getMarket();
  switch (marketCode) {
    case 'NO':
      return '/kundeservice';
    default:
      return '/kundservice';
  }
};

const ErrorView = () => {
  const { t } = useTranslation(['error', 'global']);

  return (
    <Page>
      <PageSection>
        <Container>
          <MaxWidth $maxWidth={TEXT_CONTENT_MAX_WIDTH}>
            <VStack $spacing={2}>
              <H1 $margin="none">{t('weCanNotFindThePage', { ns: 'error' })}</H1>
              <Text $size="large" $weight="bold">
                {t('hereAreSomeUsefulLinks', { ns: 'error' })}
              </Text>
              <VStack $spacing={0.5}>
                <RouterLink to="/sok" title={t('findVehicles', { ns: 'error' })}>
                  {t('findVehicles', { ns: 'error' })}
                </RouterLink>
                <RouterLink
                  to={resolveCustomerServiceRoute()}
                  title={t('customerSupport', { ns: 'error' })}
                >
                  {t('customerSupport', { ns: 'error' })}
                </RouterLink>
              </VStack>
            </VStack>
          </MaxWidth>
        </Container>
      </PageSection>
    </Page>
  );
};

export default ErrorView;
